import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'whatsapp_templates_list',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
